import React, { useRef } from "react";

import shopifyWhiteLogo from "../../images/brandLogos/shopifyWhiteLogo.webp";
import wooCommerceWhiteLogo from "../../images/brandLogos/wooCommerceWhiteLogo.webp";
import sallaWhiteLogo from "../../images/brandLogos/sallaWhiteLogo.webp";
import dropifyLogo from "../../images/brandLogos/dropifyLogo.webp";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function AvailableForSection() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      gsap.fromTo(
        sectionRef.current,
        {
          opacity: 0,
          y: 100,
        },
        {
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "top 75%",
            scrub: false,
            toggleActions: "play none none reverse",
          },
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "sine.out",
        }
      );
    },
    {
      scope: sectionRef.current,
    }
  );

  return (
    <section
      ref={sectionRef}
      className="bg-wavyBgMobile sm:bg-wavyBgTablet xl:bg-wavyBgDesktop bg-cover bg-center pt-28 xl:pt-[151px] pb-24 xl:pb-[171px] flex flex-col items-center mt-32"
    >
      <h2 className="text-[35px] xl:text-3xl text-white font-HalvarBreitBold leading-[54px] -tracking-[2%]">
        Available For
      </h2>

      <section className="w-fit flex flex-col sm:grid grid-cols-2 xl:flex xl:flex-row items-center gap-y-6 sm:gap-y-4 xl:gap-y-6 gap-x-[22px] sm:gap-x-4 xl:gap-x-[22px] mt-6">
        <div className="flex items-center justify-center w-fit sm:w-[266px] xl:w-fit h-[88px] ml-0 sm:ml-auto xl:ml-0 px-7 border-2 border-black bg-[#9FBD2F] rounded-lg shadow-[4px_4px_0_black]">
          <img src={shopifyWhiteLogo} alt="Shopify" width={185} height={56} />
        </div>
        <div className="flex items-center justify-center w-fit sm:w-[266px] xl:w-fit h-[88px] px-5 border-2 border-black bg-[#8054B3] rounded-lg shadow-[4px_4px_0_black]">
          <img
            src={wooCommerceWhiteLogo}
            alt="WooCommerce"
            width={226}
            height={52}
            loading="lazy"
          />
        </div>
        <div className="flex items-center justify-center w-fit sm:w-[266px] xl:w-fit h-[88px] px-5 border-2 border-black bg-white rounded-lg shadow-[4px_4px_0_black]">
          <img
            src={dropifyLogo}
            alt="Dropify"
            width={173}
            height={88}
            loading="lazy"
          />
        </div>
        <div className="flex items-center justify-center w-fit sm:w-[266px] xl:w-fit h-[88px] ml-0 sm:ml-auto xl:ml-0 px-7 border-2 border-black bg-[#004957] rounded-lg shadow-[4px_4px_0_black]">
          <img
            src={sallaWhiteLogo}
            alt="Salla"
            width={123}
            height={66}
            loading="lazy"
          />
        </div>
        <div className="w-fit col-span-full xl:col-span-1 mx-auto">
          <div className="mx-auto flex items-center justify-center w-fit sm:w-[266px] xl:w-fit h-[88px] px-4 border-2 border-black bg-[#FF3075] rounded-lg shadow-[4px_4px_0_black]">
            <p className="text-3xl font-gtAmericaMedium text-white leading-[46px] -tracking-[2%]">
              Custom API
            </p>
          </div>
        </div>
      </section>
    </section>
  );
}

export default AvailableForSection;
